import * as React from 'react';
import { Olapic as Olapic$1 } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsOlapic = ({ meta  })=>{
    const { locale  } = useIntl();
    return /*#__PURE__*/ React.createElement(Olapic$1, {
        instance: meta.instance,
        locale: locale.replace('-', '_'),
        olapic: meta.olapic,
        tags: meta.tags
    });
};
var Olapic = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CmsOlapic);

export { CmsOlapic, Olapic as default };
//# sourceMappingURL=Olapic.js.map
